import React, { useCallback } from "react";
import { motion } from "framer-motion";
import { Flame } from "lucide-react";
import classes from "./hotSellingToggle.module.css";

export const HotSellingToggle = React.memo(({ value = 0, onChange }) => {
  const isActive = Boolean(value);

  const toggle = useCallback(() => {
    onChange?.(isActive ? 0 : 1);
  }, [isActive, onChange]);

  return (
    <div
      className={`${classes.toggle} ${isActive ? classes.active : ""}`}
      onClick={toggle}
      role="switch"
      aria-checked={isActive}
      tabIndex={0}
      aria-label="Toggle Hot Selling Status"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      }}
    >
      <span className={classes.label}>
        {isActive ? "Hot Selling" : "Normal"}
      </span>

      <motion.div
        className={classes.knob}
        animate={{ x: isActive ? 88 : 0 }}
        transition={{
          type: "spring",
          stiffness: 280,
          damping: 22,
        }}
      >
        <motion.div
          animate={
            isActive
              ? { scale: [1, 1.15, 1], rotate: [0, 10, -10, 0] }
              : { scale: 1 }
          }
          transition={{ duration: 0.4 }}
        >
          <Flame size={16} />
        </motion.div>
      </motion.div>
    </div>
  );
});